import React from 'react'
import { StaticQuery, graphql } from 'gatsby'
import { getCurrentLanguage } from 'utils/language'

function isEnablePublic (to) {
  if (to.indexOf('http') > -1 || to.indexOf('https') > -1) return false
  return true
}

export default props => (
  <StaticQuery
    query={graphql`
      query {
        site {
          siteMetadata {
            publicUrl
          }
        }
      }
    `}
    render={data => {
      if (typeof window === 'undefined') return null
      return React.cloneElement(props.children, {
        href: isEnablePublic(props.to)
          ? data.site.siteMetadata.publicUrl + props.to + '?first=true&lng=' + getCurrentLanguage()
          : props.to
      })
    }}
  />
)
